import { RouteQueryParamsProps } from "@faire/web/common/query-params/IQueryParamsProps";
import React, { useEffect } from "react";

import { useSettingProductPageReactQuery } from "@faire/retailer/settings/useSettingProductPageReactQuery";
import { ProductCacheStore } from "@faire/retailer/stores/domain/ProductCacheStore";
import { Product } from "@faire/retailer/views/product/Product";
import { usePrefetchLeanProduct } from "@faire/retailer/views/product/utils/useLeanProductQuery";

type IProps = RouteQueryParamsProps<"/product/productToken">;

export const ProductPage: React.FC<IProps> = (props) => {
  const productPageReactQuerySetting = useSettingProductPageReactQuery();
  const productToken = props.match.params.productToken;
  const prefetchLeanProduct = usePrefetchLeanProduct(productToken);

  useEffect(() => {
    if (!productToken) {
      throw new Error("Missing productToken");
    }

    if (productPageReactQuerySetting) {
      prefetchLeanProduct();
    } else {
      ProductCacheStore.get().fetchLeanProduct(productToken);
    }
  }, [productToken, productPageReactQuerySetting, prefetchLeanProduct]);

  return <Product key={productToken} {...props} />;
};
